import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  constructor() { }
  public acc = document.getElementsByClassName("accordion");

  ngOnInit(): void {

  }

  public panel_cls:string = 'hide';
  public up_arrow_cls_name:string = 'show';
  public down_arrow_cls_name:string = 'hide';

  down_arr(){
    this.panel_cls = 'show';
    this.up_arrow_cls_name = 'hide';
    this.down_arrow_cls_name = 'show';
  }

  up_arr(){
    this.panel_cls = 'hide';
    this.down_arrow_cls_name = 'hide';
    this.up_arrow_cls_name = 'show';
  }

  //two

  public panel_cls_2:string = 'hide';
  public up_arrow_cls_name_2:string = 'show';
  public down_arrow_cls_name_2:string = 'hide';

  down_arr_2(){
    this.panel_cls_2 = 'show';
    this.up_arrow_cls_name_2 = 'hide';
    this.down_arrow_cls_name_2 = 'show';
  }

  up_arr_2(){
    this.panel_cls_2 = 'hide';
    this.down_arrow_cls_name_2 = 'hide';
    this.up_arrow_cls_name_2 = 'show';
  }



  //two

  public panel_cls_3:string = 'hide';
  public up_arrow_cls_name_3:string = 'show';
  public down_arrow_cls_name_3:string = 'hide';

  down_arr_3(){
    this.panel_cls_3 = 'show';
    this.up_arrow_cls_name_3 = 'hide';
    this.down_arrow_cls_name_3 = 'show';
  }

  up_arr_3(){
    this.panel_cls_3 = 'hide';
    this.down_arrow_cls_name_3 = 'hide';
    this.up_arrow_cls_name_3 = 'show';
  }

  //four

  public panel_cls_4:string = 'hide';
  public up_arrow_cls_name_4:string = 'show';
  public down_arrow_cls_name_4:string = 'hide';

  down_arr_4(){
    this.panel_cls_4 = 'show';
    this.up_arrow_cls_name_4 = 'hide';
    this.down_arrow_cls_name_4 = 'show';
  }

  up_arr_4(){
    this.panel_cls_4 = 'hide';
    this.down_arrow_cls_name_4 = 'hide';
    this.up_arrow_cls_name_4 = 'show';
  }


    //five

    public panel_cls_5:string = 'hide';
    public up_arrow_cls_name_5:string = 'show';
    public down_arrow_cls_name_5:string = 'hide';

    down_arr_5(){
      this.panel_cls_5 = 'show';
      this.up_arrow_cls_name_5 = 'hide';
      this.down_arrow_cls_name_5 = 'show';
    }

    up_arr_5(){
      this.panel_cls_5 = 'hide';
      this.down_arrow_cls_name_5 = 'hide';
      this.up_arrow_cls_name_5 = 'show';
    }

    //six

    public panel_cls_6:string = 'hide';
    public up_arrow_cls_name_6:string = 'show';
    public down_arrow_cls_name_6:string = 'hide';

    down_arr_6(){
      this.panel_cls_6 = 'show';
      this.up_arrow_cls_name_6 = 'hide';
      this.down_arrow_cls_name_6 = 'show';
    }

    up_arr_6(){
      this.panel_cls_6 = 'hide';
      this.down_arrow_cls_name_6 = 'hide';
      this.up_arrow_cls_name_6 = 'show';
    }

        //seven

        public panel_cls_7:string = 'hide';
        public up_arrow_cls_name_7:string = 'show';
        public down_arrow_cls_name_7:string = 'hide';

        down_arr_7(){
          this.panel_cls_7 = 'show';
          this.up_arrow_cls_name_7 = 'hide';
          this.down_arrow_cls_name_7 = 'show';
        }

        up_arr_7(){
          this.panel_cls_7 = 'hide';
          this.down_arrow_cls_name_7 = 'hide';
          this.up_arrow_cls_name_7 = 'show';
        }

            //eight

    public panel_cls_8:string = 'hide';
    public up_arrow_cls_name_8:string = 'show';
    public down_arrow_cls_name_8:string = 'hide';

    down_arr_8(){
      this.panel_cls_8 = 'show';
      this.up_arrow_cls_name_8 = 'hide';
      this.down_arrow_cls_name_8 = 'show';
    }

    up_arr_8(){
      this.panel_cls_8 = 'hide';
      this.down_arrow_cls_name_8 = 'hide';
      this.up_arrow_cls_name_8 = 'show';
    }

            //eight

            public panel_cls_9:string = 'hide';
            public up_arrow_cls_name_9:string = 'show';
            public down_arrow_cls_name_9:string = 'hide';

            down_arr_9(){
              this.panel_cls_9 = 'show';
              this.up_arrow_cls_name_9 = 'hide';
              this.down_arrow_cls_name_9 = 'show';
            }

            up_arr_9(){
              this.panel_cls_9 = 'hide';
              this.down_arrow_cls_name_9 = 'hide';
              this.up_arrow_cls_name_9 = 'show';
            }
  }
